import _ from "lodash";
import { getMemoizedFunction } from "Utils";

const getPracticesIds = ({ practices }) => _.map(practices, ({ id }) => id);

export const getPracticesIdsMemoized = getMemoizedFunction(getPracticesIds);
